import { render, staticRenderFns } from "./commonConfig.vue?vue&type=template&id=fc3b5328&scoped=true&"
import script from "./commonConfig.vue?vue&type=script&lang=js&"
export * from "./commonConfig.vue?vue&type=script&lang=js&"
import style0 from "./commonConfig.vue?vue&type=style&index=0&lang=less&"
import style1 from "./commonConfig.vue?vue&type=style&index=1&id=fc3b5328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3b5328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc3b5328')) {
      api.createRecord('fc3b5328', component.options)
    } else {
      api.reload('fc3b5328', component.options)
    }
    module.hot.accept("./commonConfig.vue?vue&type=template&id=fc3b5328&scoped=true&", function () {
      api.rerender('fc3b5328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/styleComp/commonConfig.vue"
export default component.exports